/**
 * Shared parent JS entry point — loaded by ALL sites.
 *
 * Initializes shared components, blocks, and animations.
 */

import './polyfills';
import Header from "./components/Header";
import SliderSingle from "./blocks/slider-single";
import SliderMulti from "./blocks/slider-multi";
import SliderGridSwipe from "./blocks/slider-grid-swipe";
import Video from "./blocks/video";
import SliderVideo from "./blocks/slider-video";
import Accordion from "./blocks/accordion";
import Select from "./components/Select";
import Tab from "./blocks/tab";
import InteractiveImage from "./blocks/interactiveimage";
import Footer from "./components/Footer";
import Gated from "./components/Gated";
import Newsletter from "./components/Newsletter";
import Contact from "./components/Contact";
import News from "./components/News";
import Animation from "./animations/_main";
import Offices from "./components/Offices";
import Wysiwyg from "./blocks/wysiwyg";
import Menu from "./components/Menu";
import TeamTailorJobs from "./blocks/teamtailor-jobs";
import TeamTailorJobForm from "./blocks/teamtailor-job-form";
import GetInTouchPopup from "./components/GetInTouchPopup";
import HeroHomeBlurMask  from './blocks/hero-home-blur-mask'

if (document.querySelector(".nostickycontact")) {
    const page = document.querySelector("#page");

    if (page) {
        page.classList.add("nostickycontact");
    }
}

document.addEventListener("DOMContentLoaded", function () {
    function init() {
        Tab.init();
        Wysiwyg.init();
        Animation.init();
        Offices.init();
        Header.init();
        Footer.init();
        SliderSingle.init();
        SliderMulti.init();
        SliderGridSwipe.init();
        Video.init();
        SliderVideo.init();
        Accordion.init();
        InteractiveImage.init();
        Gated.init();
        Newsletter.init();
        Contact.init();
        Select.init();
        News.init();
        Menu.init();
        TeamTailorJobs.init();
        TeamTailorJobForm.init();
        GetInTouchPopup.init();
        HeroHomeBlurMask.init();
    }

    if (document.fonts.status === 'loaded') {
        init();
    } else {
        document.fonts.ready.then(init);
    }
});
